import { Flex, Spacer, Toggle, Typography, useTheme } from '@aircall/tractor';
import { GridItem, GridLayout } from '@components/GridLayout/GridLayout';
import { ListItem } from '@components/ListItem/ListItem';
import { UserFullFragment_sipSettings } from '@generated/UserFullFragment';
import { useSipDeviceRow } from '@hooks/useSipDeviceRow';
import { useTranslation } from 'react-i18next';

interface SIPDeviceRowProps {
  sipSetting: UserFullFragment_sipSettings;
}

export function SIPDeviceRow({ sipSetting }: SIPDeviceRowProps) {
  const { t } = useTranslation();
  const { colors, radii } = useTheme();
  const { isToggleLoading, handleDeleteSipDevice, handleToggleChange } = useSipDeviceRow(
    sipSetting.ID
  );

  return (
    <ListItem
      dropdownOptions={[
        {
          title: t('user_profile.call_preferences.forward_call_sip.remove_button'),
          callback: handleDeleteSipDevice,
        },
      ]}
      height='max-content'
      data-test={`${sipSetting.type}-device-row-${sipSetting.ID}`}
    >
      <GridLayout p='s' alignItems='center' position='relative' justifyContent='start' width='100%'>
        <GridItem xs={12} md={6} paddingRight={{ _: 'm', md: 0 }}>
          <Spacer
            border={`1px solid ${colors.base.black}`}
            borderRadius={radii[8]}
            padding='xxs'
            direction='vertical'
            fluid
          >
            <Flex flexWrap='wrap'>
              <Typography color='text.dark' mr='xxxs'>
                {t('user_profile.call_preferences.forward_call_sip.domain')}:
              </Typography>
              <Typography> {sipSetting.domain}</Typography>
            </Flex>
            <Flex flexWrap='wrap'>
              <Typography color='text.dark' mr='xxxs'>
                {t('user_profile.call_preferences.forward_call_sip.username')}:
              </Typography>
              <Typography>{sipSetting.username}</Typography>
            </Flex>
            {sipSetting.type === 'TwilioSipSetting' && (
              <Flex flexWrap='wrap'>
                <Typography color='text.dark' mr='xxxs'>
                  {t('user_profile.call_preferences.forward_call_sip.password')}:
                </Typography>
                <Typography>{sipSetting.password}</Typography>
              </Flex>
            )}
          </Spacer>
        </GridItem>
        <GridItem xs={12} md={6}>
          <Spacer space='s' alignItems='center'>
            <Toggle
              size='small'
              checked={sipSetting.isEnabled}
              onChange={!isToggleLoading ? handleToggleChange : undefined}
              data-test={`${sipSetting.type}-toggle-${sipSetting.ID}`}
            />
            <Typography color='text.dark'>
              {t('user_profile.call_preferences.forward_call_sip.activate_device')}
            </Typography>
          </Spacer>
        </GridItem>
      </GridLayout>
    </ListItem>
  );
}
